"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionLimit = exports.LossLimit = exports.DepositLimit = exports.CoolingOffLimit = exports.BetLimit = void 0;
var BetLimit_1 = require("./BetLimit");
Object.defineProperty(exports, "BetLimit", { enumerable: true, get: function () { return __importDefault(BetLimit_1).default; } });
var CoolingOffLimit_1 = require("./CoolingOffLimit");
Object.defineProperty(exports, "CoolingOffLimit", { enumerable: true, get: function () { return __importDefault(CoolingOffLimit_1).default; } });
var DepositLimit_1 = require("./DepositLimit");
Object.defineProperty(exports, "DepositLimit", { enumerable: true, get: function () { return __importDefault(DepositLimit_1).default; } });
var LossLimit_1 = require("./LossLimit");
Object.defineProperty(exports, "LossLimit", { enumerable: true, get: function () { return __importDefault(LossLimit_1).default; } });
var SessionLimit_1 = require("./SessionLimit");
Object.defineProperty(exports, "SessionLimit", { enumerable: true, get: function () { return __importDefault(SessionLimit_1).default; } });
